import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, tryNormalizeHttpError, UserAddressConnector } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { CustomCheckoutActions } from '../actions';

@Injectable()
export class AddressVerificationEffect {
  protected logger = inject(LoggerService);
  verifyAddress$: Observable<CustomCheckoutActions.VerifyAddressSuccess | CustomCheckoutActions.VerifyAddressFail> = createEffect(() =>
    this.actions$.pipe(
      ofType<CustomCheckoutActions.VerifyAddress>(CustomCheckoutActions.VERIFY_ADDRESS),
      map((action) => action.payload),
      mergeMap((payload) =>
        this.userAddressConnector.verify(payload.userId, payload.address).pipe(
          map((data) => new CustomCheckoutActions.VerifyAddressSuccess(data)),
          catchError((error) => of(new CustomCheckoutActions.VerifyAddressFail(tryNormalizeHttpError(error, this.logger))))
        )
      )
    )
  );

  constructor(private actions$: Actions, private userAddressConnector: UserAddressConnector) {}
}
